import { getProductAndPlanFromSku } from '@hotjar/product-catalog';
import { getBasicSkuFromChargeableSku } from '~/product-catalog/utils/get-utils';
import type { ProductAllowance } from '../api/common/model/subscription';

export function planIsBasic(allowance: ProductAllowance): boolean {
  return getProductAndPlanFromSku(allowance.sku).plan.name === 'basic';
}

export function planIsNotBasic(allowance: ProductAllowance): boolean {
  return getProductAndPlanFromSku(allowance.sku).plan.name !== 'basic';
}

export function removeAllowancesOnBasic(allowances: ProductAllowance[] = []): ProductAllowance[] {
  return allowances.filter(planIsNotBasic);
}

export function convertAllowancesToBasic(allowances: ProductAllowance[] = []): ProductAllowance[] {
  return allowances.map((allowance) => ({
    ...allowance,
    sku: getBasicSkuFromChargeableSku(allowance.sku),
  }));
}

export const convertReadableNumber = (amount: number): string => {
  if (amount < 1000) {
    return `${amount}`;
  }

  return `${amount / 1000}k`;
};

export function isAllBasic(allowances: ProductAllowance[] = []): boolean {
  return allowances.every(planIsBasic);
}
